<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资产归还</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :queryOnLoad="queryOnLoad" :configAuto="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('device_return')" @click="toSaveDeviceAppTurn">制作归还单</button>
            </div>
        </div>
        <div name="tabs-block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="0"></el-tab-pane>
                <el-tab-pane name="1">
                    <span slot="label">未申请<i class="num-marker">{{initialCount}}</i></span>
                </el-tab-pane>
                <el-tab-pane name="2">
                    <span slot="label">未审核<i class="num-marker">{{appliedCount}}</i></span>
                </el-tab-pane>
                <el-tab-pane label="审核通过" name="3"></el-tab-pane>
                <el-tab-pane name="4">
                    <span slot="label">审核未通过<i class="num-marker">{{auditFailCount}}</i></span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, Routes, MsgBox, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'
    import { loadShopWarehouseList } from '../retailer/asset-comn'
    //
    import shopDevcApi from '../../api/shopDevc'
    import shopStockApi from '../../api/shopStock'
    import assetVchrApi from '../../api/assetVchr'
    //
    import SwbShopDeviceAppturnVoucherSave from './ShopDeviceAppturnVoucherSave'
    Routes.add(SwbShopDeviceAppturnVoucherSave);

    import SwbShopDeviceApptrurnVoucherEdit from './ShopDeviceApptrurnVoucherEdit'
    Routes.add(SwbShopDeviceApptrurnVoucherEdit);

    import SwbShopDeviceAppturnVoucherInfo from './ShopDeviceAppturnVoucherInfo'
    Vue.regist(SwbShopDeviceAppturnVoucherInfo);

    import SwbShopDeviceRecList from './ShopDeviceRecList'
    Vue.regist(SwbShopDeviceRecList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-shop-device-appReturn-voucher-list',
        path: '/shop/device/return/voucher/list',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '资产归还列表',
        data: function () {
            return {
                confKey: "swb-shop-device-appReturn-voucher-list",
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                resultColConf: null,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //排序、搜索
                queryConfig: {},
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                activeName: 0,
                no: null,
                initialCount: 0,
                appliedCount: 0,
                auditFailCount: 0,
            }
        },
        created: function () {
            //
            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.queryModel.filterItems.no = no;
                this.no = no;
            }
            //
            this.fetchData();
        },
        watch: {
            '$route': 'fetchData'
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout,[name="query-sort-area"],.simple-row,[name="tabs-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function () {
                let self = this;
                // 加载仓库
                loadShopWarehouseList(self.thisComId, function (dataList) {
                    self.updateQueryModelField("warehouseId", dataList);
                });
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let no = this.no;
                if(!Utils.isNoB(no)) {
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{

                    'auditState': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.applyState == 0) {
                            return '<span>未申请</span>';
                        } else if(row.applyState == 1) {
                            return '<span>未审核</span>';
                        } else if(row.applyState == 2) {
                            if(colValue === 1) {
                                return '<span class="font-green">审核通过</span>';
                            } else if(colValue === -1) {
                                return '<span class="font-red">审核未通过</span>';
                            }
                        }
                    },
                    'createOutVoucher': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.createOutVoucher) {
                            return '<span class="font-green">已生成</span>';
                        } else {
                            return '<span class="font-red">未生成</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if(self.checkActionPerm('view')) {
                            btnList.push({
                                name: 'view',
                                text: '查看'
                            })
                        }
                        if(self.checkActionPerm('modify') && row.applyState != 1 && row.auditState != 1) {
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            })
                        }
                        if(self.checkActionPerm('apply') && row.applyState != 1 && row.auditState != 1) {
                            btnList.push({
                                name: 'apply',
                                text: '申请'
                            })
                        }
                        if((row.auditorPostId == null && self.checkActionPerm('audit') || self.checkActionPerm('audit', row.auditorPostId)) && row.applyState == 1 && row.auditState != 1) {
                            btnList.push({
                                name: 'audit',
                                text: '审核'
                            })
                        }
                        if(self.checkActionPerm('delete') && ((row.auditState == -1 && row.applyState != 1) || row.applyState == 0)) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            })
                        }
                        if(self.checkActionPerm('view_rec')) {
                            btnList.push({
                                name: 'view_rec',
                                text: '操作记录'
                            })
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view') {
                            self.viewInAppTurn(row.id);
                        } else if(btnName == 'modify') {
                            self.editoReturnVoucher(row.id);
                        } else if(btnName == 'apply') {
                            self.applyReturnDevice(row);
                        } else if(btnName == 'audit') {
                            self.auditReturnDevice(row);
                        } else if(btnName == 'delete') {
                            self.doDeleteReturnDevice(row.id);
                        } else if(btnName == 'view_rec') {
                            self.showActRec(row.no);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            fetchData: function () {
                this.pageSize = this.pageSizes.first();
            },
            // 操作权限控制
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //缓存查询条件
                this.toGetShopDeviceAppturnVoucherList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.toGetShopDeviceAppturnVoucherList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.toGetShopDeviceAppturnVoucherList();
            },
            handleClick() {
                this.handlePageChange(1);
            },
            toGetShopDeviceAppturnVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);

                //
                let activeName = self.activeName;
                filterItems.applyState = null;
                filterItems.auditState = null;
                if(activeName == 1) {
                    filterItems.applyState = 0;
                    filterItems.auditState = 0;
                } else if(activeName == 2) {
                    filterItems.applyState = 1;
                    filterItems.auditState = 0;
                } else if(activeName == 3) {
                    filterItems.applyState = 2;
                    filterItems.auditState = 1;
                } else if(activeName == 4) {
                    filterItems.applyState = 2;
                    filterItems.auditState = -1;
                }
                filterItems.ioFlag = -1;
                filterItems.activeName = activeName;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceAppturnVoucherList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows, pagination);
                        self.getApplyStateInitialTodoCount();
                        self.getApplyStateAppliedTodoCount();
                        self.getAuditStateAuditFailTodoCount();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getApplyStateInitialTodoCount: function () {
                let self = this;
                assetVchrApi.getShopDeviceReturnVoucherApplyStateInitialTodoCount({}, function (result) {
                    if(result.type == "info") {
                        self.initialCount = result.data;
                    }
                })
            },
            getApplyStateAppliedTodoCount: function () {
                let self = this;
                assetVchrApi.getShopDeviceReturnApplyStateAppliedVoucherTodoCount({
                    applyFlag: true
                }, function (result) {
                    if(result.type == "info") {
                        self.appliedCount = result.data;
                    }
                })
            },
            getAuditStateAuditFailTodoCount: function () {
                let self = this;
                assetVchrApi.getShopDeviceReturnVoucherAuditStateAuditFailTodoCount({}, function (result) {
                    if(result.type == "info") {
                        self.auditFailCount = result.data;
                    }
                })
            },
            // 制作归还单
            toSaveDeviceAppTurn: function () {
                this.$router.push({
                    path: SwbShopDeviceAppturnVoucherSave.path,
                    query: {
                        ioFlag: getEnumInfoWith('ioFlag', 'name', 'IoOut').value,
                        isFixedWarehouse: false
                    }
                });
            },
            editoReturnVoucher: function (id) {
                this.$router.push({
                    path: SwbShopDeviceApptrurnVoucherEdit.path,
                    query: {
                        ioFlag: getEnumInfoWith('ioFlag', 'name', 'IoOut').value,
                        voucherId: id,
                        isFixedWarehouse: false
                    }
                });
            },
            // 归还单查看
            viewInAppTurn: function (id) {
                Vue.$showDialog({
                    title: "资产归还单--详情",
                    width: 1300,
                    height: 880,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<swb-shop-device-appturn-voucher-info :voucherId="id" :ioFlag="-1"></swb-shop-device-appturn-voucher-info>',
                    data: {
                        id: id,
                    }
                });
            },
            // 申请归还单
            applyReturnDevice: function (row) {
                let self = this;
                showComActionPostSelectDlg({
                    title: '归还单申请 - 指定审核岗',
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                    useParents: false,
                    initPostId: row.auditorPostId,
                    applyDesc: row.applyDesc
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: row.id,
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.postName,
                        auditComId: resultData.comId,
                        auditComName: resultData.comName,
                        auditComLevel: resultData.comLevel,
                        applyDesc: resultData.applyDesc,
                        autoAuditPass: false
                    };
                    //
                    let theLoad = MsgBox.loading();
                    assetVchrApi.applyShopDeviceAppturnVoucher(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            MsgBox.success('申请成功！');
                            self.toGetShopDeviceAppturnVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },
            // 审核报废单
            auditReturnDevice: function (row) {
                let self = this;
                showBizAuditDlg({
                    title: "归还单",
                }, function (resultData) {
                    resultData = resultData || {};
                    let postData = {
                        id: row.id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                    };
                    let theLoad = MsgBox.loading();
                    assetVchrApi.aduitShopDeviceAppturnVoucher(postData, function (result) {
                        if(result.type == 'info') {
                            self.toGetShopDeviceAppturnVoucherList();
                            MsgBox.success('操作成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                }, this);
            },

            // 删除报废单
            doDeleteReturnDevice: function (id) {
                let self = this;
                self.$confirm('确定要删除该信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    assetVchrApi.deleteShopDeviceAppturnVoucher(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.toGetShopDeviceAppturnVoucherList();
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            showActRec(no){
                Vue.$showDialog({
                    title: "归还单操作记录 - 查看",
                    width: 1200,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-act-rec-list :showComFlag="false" :srcVoucherNo="srcVoucherNo" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                    '</div>',
                    data: {
                        srcVoucherNo: no,
                        srcVoucherType: getEnumInfoWith("devcVoucherType", "name", "Appturn").value
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceAppReturnVoucherList.vue